import React from "react";

import HeadingDesignElement from "../../../../assets/FooterHeadingDesignElement.svg";
import DesignElement from "../../../../assets/PartnerFooterDesignElement.svg";
import {useMediaQuery} from "../../../../hooks/useMediaQuery";
import HeadTwo from "../../../HeadTwo/HeadTwo";
import {Button} from "../Button";
import "./styles.scss";

const PartnerFooter = ({color = "#5D48D8"}) => {
  const isMobile = useMediaQuery("(max-width: 900px)");
  return (
    <div className='p-foot-wrap text-center md:my-12 mt-12 mb-4  relative'>
      <HeadTwo
        showOtherContent={isMobile}
        otherContent={<HeadingDesignElement className='heading-left' />}
      >
        ⚡ <br /> We’re movers & shakers <br /> We’re growing quick!
      </HeadTwo>
      <h4 className='p-foot-subtitle w-full md:w-3/4 mx-auto px-4 mt-4 md:mt-8 font-normal'>
        We are on a mission to help brands of all sizes optimise their in-store
        conversions with visual merchandising.
      </h4>
      {!isMobile && (
        <>
          <br />
          <br />
        </>
      )}
      <div className='stats-wrap flex flex-row flex-wrap justify-center text-center'>
        <div className='stat w-1/3'>
          <h3 style={{color}}>4.9</h3>
          <h4 className='medium'>Rated Application</h4>
        </div>
        <div className='stat w-1/3'>
          <h3 style={{color}}>10K +</h3>
          <h4 className='medium'>Application Installs</h4>
        </div>
        <div className='stat w-1/3'>
          <h3 style={{color}}>15%</h3>
          <h4 className='medium'>Avg. Sales Growth</h4>
        </div>
        {/* <div className="stat w-2/4 md:w-1/4">
          <h3 style={{ color: color }}>15%</h3>
          <h4 className="medium">Sales Growth</h4>
        </div> */}
      </div>
      {!isMobile && (
        <>
          <br />
          <br />
        </>
      )}
      <Button className='primary-cta inline-block md:m-2 my-12' />
      <DesignElement className='design-element' />
    </div>
  );
};

export default PartnerFooter;
